/* TypeScript file generated from Root.res by genType. */

/* eslint-disable */
/* tslint:disable */

import * as RootJS from './Root.res.js';

export type props = {};

export const make: React.ComponentType<{}> = RootJS.make as any;
